import Component from 'vue-class-component';
import {RegistrationVue} from '@/registration-vue';
import './clubcard-choose-reward.scss';
import * as SmoothScroll from '../../../vendor/smooth-scroll.js';
import {Watch} from 'vue-property-decorator';

@Component({template: require('./clubcard-choose-reward.html')})
export class ClubCardChooseRewardPage extends RegistrationVue {

  mounted() {
    this.$validator.updateDictionary({
                                       en: {
                                         custom: {
                                           airpointsnumber: {
                                             required: 'Please enter your Airpoints number',
                                             min: 'Airpoints number should be 8 digits',
                                             digitsonly: 'Airpoints number needs to be digits only'
                                           },
                                           flybuysnumber: {
                                             required: 'Please enter your Fly Buys number',
                                             min: 'Fly Buys number should be 16 digits',
                                             digitsonly: 'Fly Buys number needs to be digits only'
                                           }
                                         }
                                       }
                                     });
  }

  next() {
    this.doIfFormIsValid(() => {
      this.navigate('clubcard-details-entry');
    });
  }

  setupLater() {
    this.$store.state.isQuickShopper = true;
    this.navigate('security-entry');
  }

  @Watch('$store.state.flybuysOption')
  @Watch('$store.state.airpointsOption')
  onMembershipChanged(newValue: string) {
    console.log('watch happened');
    if (newValue == 'member'){
      setTimeout(() => {
        console.log('animate scroll');
        console.log(SmoothScroll.animateScroll);
        SmoothScroll.animateScroll(this.$refs.pageBottom, undefined, { speed: 300, easing: 'easeOutCubic' });
      }, 50);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/forms/clubcard-choose-reward/clubcard-choose-reward.ts